import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LogIn, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { pageVariants } from './utils';
import { CheckInForm } from './CheckInForm';
import { BitsyCheckinView } from './BitsyCheckinView';
import { useGuestPortal } from './GuestPortalContext';

export function CheckInWrapper({ setView, setSuccessMessage, setNoticeAccepted, acceptedNoticeId, setAcceptedNoticeId, bitsyCrewEnabled }) {
  const { t, language } = useGuestPortal();
  const [mode, setMode] = useState(null);
  
  if (!bitsyCrewEnabled && mode === null) {
    return <CheckInForm setView={setView} setSuccessMessage={setSuccessMessage} setNoticeAccepted={setNoticeAccepted} acceptedNoticeId={acceptedNoticeId} setAcceptedNoticeId={setAcceptedNoticeId} />;
  }
  
  if (mode === 'form') {
    return <CheckInForm setView={setView} setSuccessMessage={setSuccessMessage} setNoticeAccepted={setNoticeAccepted} acceptedNoticeId={acceptedNoticeId} setAcceptedNoticeId={setAcceptedNoticeId} />;
  }
  
  if (mode === 'bitsy') {
    return <BitsyCheckinView setView={setView} setSuccessMessage={setSuccessMessage} onSwitchToForm={() => setMode('form')} />;
  }
  
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="w-full max-w-md"
    >
      <Card className="bg-vault-surface border border-vault-border shadow-xl p-6 rounded-2xl">
        <CardHeader className="text-center pb-6">
          <CardTitle className="font-outfit text-2xl font-bold text-vault-text">
            {language === 'es' ? '¿Cómo desea registrarse?' : 'How would you like to check in?'}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={() => setMode('bitsy')}
            className="w-full h-20 text-lg flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-bold"
            data-testid="bitsy-checkin-btn"
          >
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            <span>{t.talkToBitsy || "Talk to Bitsy"}</span>
          </Button>
          
          <Button
            onClick={() => setMode('form')}
            className="w-full h-16 text-lg flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold"
            data-testid="quick-checkin-btn"
          >
            <LogIn className="w-5 h-5" />
            <span>{t.quickCheckIn || "Quick Check-In"}</span>
          </Button>
          
          <Button
            onClick={() => setView("menu")}
            variant="outline"
            className="w-full h-12 flex items-center justify-center gap-2 mt-4"
            data-testid="back-to-menu-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            {t.backToMenu || "Back to Menu"}
          </Button>
        </CardContent>
      </Card>
    </motion.div>
  );
}
